<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showEditButton="showEditButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-edit-form="$emit('open-edit-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as BANK_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'BankTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'iban',
          label: this.$t('IBAN'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'iban'
        },
        {
          key: 'abi',
          label: this.$t('ABI'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'abi'
        },
        {
          key: 'cab',
          label: this.$t('CAB'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'cab'
        },
        {
          key: 'int_code',
          label: this.$t('INT'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'int_code'
        },
        {
          key: 'cin',
          label: this.$t('CIN'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'cin'
        },
        {
          key: 'cc',
          label: this.$t('CC'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'cc'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'name']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: BANK_TYPES.GENERIC.bank.bank.LIST.GETTERS.selectAll,
      selectedList: BANK_TYPES.GENERIC.bank.bank.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showEditButton () {
      return hasPerm('bank_bank_update')
    }
  },
  methods: {
    ...mapMutations({
      setList: BANK_TYPES.GENERIC.bank.bank.LIST.MUTATIONS.setList,
      setSelectedList:
        BANK_TYPES.GENERIC.bank.bank.LIST.MUTATIONS.setSelectedList,
      setSelectAll: BANK_TYPES.GENERIC.bank.bank.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...BANK_TYPES.GENERIC.bank.bank.LIST.ACTIONS
    })
  }
}
</script>
